import { persistStore, persistCombineReducers } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { createStore, applyMiddleware, compose } from 'redux'
import reducers from './reducers'
import thunk from 'redux-thunk'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const config = {
  key: 'root',
  storage,
  blacklist: ["form"]
}

const persistedReducer = persistCombineReducers(config, reducers)

function configureStore () {
  let store = createStore(
    persistedReducer,
    composeEnhancers(
      applyMiddleware(thunk)
    )
  )
  let persistor = persistStore(store)
  return { store, persistor }
}

export default configureStore;



// WEBPACK FOOTER //
// ./src/store.js